const de = {
    //login
    greeting: "Wenn Sie mehr ausgeben, als Sie verdienen, werden Sie immer arm sein.",
    username: "Benutzername:",
    registration: "REGISTRIERUNG",
    log_required: "erforderlich",
    pass: "Passwort:",
    in: "ANMELDEN",
    //registration
    required: "erforderlich",
    bevare_name_length: "Der Benutzername muss mindestens 4 Zeichen lang sein.",
    bevare_name_matches: "Der Benutzername darf nur ateinische Buchstaben und Zahlen enthalten.",
    bevare_pass_length: "Das Passwort darf nicht weniger als 4 Zeichen lang sein.",
    bevare_pass_matches: "Das Passwort darf nur ateinische Buchstaben und Zahlen enthalten.",
    bevare_pass_check: "Passwörter stimmen nicht überein.",
    reg_pass: "Passwort:",
    reg_to_log: "ANMELDUNG",
    check_pass: "Passwort wiederholen:",
    reg_button: "REGISTRIEREN",
    reg_username: "Benutzername:",
    //logined
    logined_trans_button_text: "Hinzufügen",
    logined_trans_list: "TRANSAKTIONSLISTE:",
    //navbar
    new_transaction: "neue Transaktion",
    transaction_statistic: "Transaktionsstatistik",
    transaction_history: "Transaktionshistorie",
    calc: "Rechner",
    //transaction
    transaction_date: "Datum:",
    transaction_amount: "Betrag:",
    transaction__details: "Details:",
    //transaction form
    tf_data: "Datum:",
    tf_type: "Typ:",
    tf_expence: "Ausgabe",
    tf_income: "Einnahme",
    tf_placeholder_target: "Ziel der Ausgabe",
    tf_placeholder_amount: "Betrag",
    tf_error: "Leider ist die Aktion fehlgeschlagen. Bitte versuchen Sie es später erneut.",
    tf_complite: "Eintrag hinzugefügt",
    //edit transaction
    et_update: "aktualisieren",
    et_cancel: "abbrechen",
    //delete transaction
    dt_delete: "Möchten Sie den Eintrag löschen?",
    dt_error: "Leider ist das Löschen fehlgeschlagen, bitte versuchen Sie es später erneut.",
    dt_complite: "Aufzeichnung gelöscht",
    //transaction controls
    tr_contrl_oldbegin: "Älteste zuerst",
    tr_contrl_newbegin: "Neueste zuerst",
    tr_contrl_reload: "Daten aktualisieren",
    tr_contrl_find: "Gesuchter Transaktionstyp",
    //summary
    sum_total_income: "Gesamteinnahmen:",
    sum_total_expence: "Gesamtausgaben:",
    sum_total_remain: " Verbleibend:",
    sum_search_in_budget: "Suche in Ausgaben:",
    sum_search: "Suche",
    sum_summary_expenses_bytype: "Gesamtausgaben nach Typ:",
    expence_by_month: "Ausgaben nach Monat",
};

export default de;
